export default "__VITE_PUBLIC_ASSET__e45179c5__"